module.exports = __webpack_public_path__ + "img/sign-7.dfa86371.jpg";